import { render, staticRenderFns } from "./RPSCaseChoiceField.vue?vue&type=template&id=0f0b9238&scoped=true"
import script from "./RPSCaseChoiceField.vue?vue&type=script&lang=js"
export * from "./RPSCaseChoiceField.vue?vue&type=script&lang=js"
import style0 from "./RPSCaseChoiceField.vue?vue&type=style&index=0&id=0f0b9238&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0b9238",
  null
  
)

/* custom blocks */
import block0 from "./RPSCaseChoiceField.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports